export var LOADING_APP = "LOADING_APP";
export var UPDATE_AUTH_TOKEN = "UPDATE_AUTH_TOKEN";
export var ERROR_PRELOAD_APP = "ERROR_PRELOAD_APP";
export var UPDATE_SADMIN = "UPDATE_SADMIN";
export function loadingApp(bool) {
    return {
        payload: bool,
        type: LOADING_APP,
    };
}
export function updateAuthToken(token) {
    return {
        type: UPDATE_AUTH_TOKEN,
        payload: token,
    };
}
export function updateSAdmin(admin) {
    return {
        type: UPDATE_SADMIN,
        payload: admin,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/actions/app.ts
// module id = 42
// module chunks = 0